import * as React from "react";
import { Chip, styled } from "@mui/material";

const CustomChip = styled(Chip)({
  boxSizing: " border-box",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  padding: " 8px 16px",
  color: "#9EA3AE",
  gap: "10px",
  width: "111px",
  height: "36px",
  background: "#FFFFFF",
  border: " 1px solid #E1E1E6",
  borderRadius: "32px",
});
export default function BasicChips({ label,id, onClick }) {
  return (
    <CustomChip
      onClick={()=>{onClick(id)}}
      sx={{
        "& .MuiChip-label": {
          height: "20px",
          fontFamily: "Outfit",
          fontStyle: "normal",
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "140%",
          letterSpacing: "0.015em",
          color: "#9EA3AE",
          overflow: "visible",
        },
      }}
      label={label}
      variant="outlined"
    />
  );
}
